import React from 'react';
import './UpdateCard.css';

function UpdateCard({ update, sourceInfo }) {
  const urgencyIcons = {
    critical: '🔴',
    high: '🟠',
    medium: '🟡',
    low: '🟢'
  };

  const urgencyLabels = {
    critical: 'Critical',
    high: 'High',
    medium: 'Medium',
    low: 'Low'
  };

  const getUrgencyColor = (urgency) => {
    const colors = {
      critical: '#e74c3c',
      high: '#f39c12',
      medium: '#3498db',
      low: '#27ae60'
    };
    return colors[urgency] || '#3498db';
  };

  const publishDate = new Date(update.published_at);
  const dateStr = publishDate.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric' 
  });

  return (
    <div className="update-card" style={{ borderLeftColor: getUrgencyColor(update.urgency) }}>
      <div className="update-top">
        <div className="source-header">
          {sourceInfo?.icon && <span className="source-icon">{sourceInfo.icon}</span>}
          <span className="source-label">{sourceInfo?.label || update.source?.toUpperCase()}</span>
        </div>
        <span className={`urgency-badge urgency-${update.urgency}`}>
          {urgencyIcons[update.urgency]} {urgencyLabels[update.urgency] || 'Medium'}
        </span>
      </div>

      <h3 className="update-title">{update.title}</h3>

      <p className="update-description">{update.ai_summary || update.description}</p>

      {update.tags && update.tags.length > 0 && (
        <div className="tags">
          {(Array.isArray(update.tags) ? update.tags : update.tags.split(',').map(t => t.trim()).filter(Boolean))
            .slice(0, 3)
            .map(tag => (
              <span key={tag} className="tag">{tag}</span>
            ))}
        </div>
      )}

      <div className="update-footer">
        <small className="update-date">📅 {dateStr}</small>
        {update.url && (
          <a 
            href={update.url} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="read-article-btn"
          >
            Read Article →
          </a>
        )}
      </div>
    </div>
  );
}

export default UpdateCard;
